import axios from 'axios'
import QS from 'qs'
// 环境的切换
if (process.env.NODE_ENV == 'development') {
	// axios.defaults.baseURL = 'http://192.168.0.113/';
	axios.defaults.baseURL = 'https://www.spmall.com/';
} else if (process.env.NODE_ENV == 'debug') {
	// axios.defaults.baseURL = 'http://192.168.0.113/';
	axios.defaults.baseURL = 'https://www.spmall.com/';
} else if (process.env.NODE_ENV == 'production') {
	axios.defaults.baseURL = 'https://www.spmall.com/';
}
console.log(process.env.NODE_ENV);
//请求超时设置
axios.defaults.timeout = 10000
// 请求头
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
 
// 响应拦截器
axios.interceptors.response.use(
	response => {
		// 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据     
		// 否则的话抛出错误
		if (response.status === 200) {
			return Promise.resolve(response);
		} else {
			return Promise.reject(response);
		}
	},
	// 服务器状态码不是2开头的的情况
	// 这里可以跟你们的后台开发人员协商好统一的错误状态码    
	// 然后根据返回的状态码进行一些操作，例如登录过期提示，错误提示等等
	// 下面列举几个常见的操作，其他需求可自行扩展
	error => {
		if (error.response.status) {
			switch (error.response.status) {
				// 401: 未登录
				// 未登录则跳转登录页面，并携带当前页面的路径
				// 在登录成功后返回当前页面，这一步需要在登录页操作。                
				case 401:
					router.replace({
						path: '/Login'
					});
					break;

					// 403 token过期
					// 登录过期对用户进行提示
					// 清除本地token和清空vuex中token对象
					// 跳转登录页面                
				case 403:
					this.$message({
						showClose: false,
						message: '登陆过期，请重新登陆',
						type: 'error'
					})
					// 清除token
					localStorage.removeItem('token');
					store.commit('loginSuccess', null);
					// 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面 
					setTimeout(() => {
						router.replace({
							path: '/Login'
						});
					}, 1000);
					break;

					// 404请求不存在
				case 404:
					this.$message({
						showClose: false,
						message: '网络请求页面不存在',
						type: 'error'
					})
					break;
					// 其他错误，直接抛出错误提示
				default:
					this.$message({
						showClose: false,
						message: error.response.data.message,
						type: 'error'
					})
			}
			return Promise.reject(error.response);
		}
	}
);
// 封装get和post方法
export function get(url, params) {
	return new Promise((resolve, reject) => {
		axios.get(url, {
			params: params
		}).then(res => {
			resolve(res.data)
		}).catch(err => {
			reject(err.data)
		})
	})
}
export function post(url, params) {
	return new Promise((resolve, reject) => {
		axios.post(url, QS.stringify(params))
			.then(res => {
				resolve(res.data)
			})
			.catch(err => {
				reject(err.data)
			})
	})
}

export function postFile(url, params,formDate) {
	return new Promise((resolve, reject) => {
		axios.post(url, QS.stringify(params),formDate)
			.then(res => {
				resolve(res.data)
			})
			.catch(err => {
				reject(err.data)
			})
	})
}
export function postDownload(url, params,) {
	return new Promise((resolve, reject) => {
		axios.post(url, QS.stringify(params),{responseType: 'arraybuffer'})
			.then(res => {
				resolve(res.data)
			})
			.catch(err => {
				reject(err.data)
		})
	})
}

